"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelPremiumResponseAllOfToJSON = exports.CancelPremiumResponseAllOfFromJSONTyped = exports.CancelPremiumResponseAllOfFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CancelPremiumResponseAllOfFromJSON(json) {
    return CancelPremiumResponseAllOfFromJSONTyped(json, false);
}
exports.CancelPremiumResponseAllOfFromJSON = CancelPremiumResponseAllOfFromJSON;
function CancelPremiumResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'customerStatus': !(0, runtime_1.exists)(json, 'customerStatus') ? undefined : (0, _1.CustomerStatusFromJSON)(json['customerStatus']),
    };
}
exports.CancelPremiumResponseAllOfFromJSONTyped = CancelPremiumResponseAllOfFromJSONTyped;
function CancelPremiumResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'customerStatus': (0, _1.CustomerStatusToJSON)(value.customerStatus),
    };
}
exports.CancelPremiumResponseAllOfToJSON = CancelPremiumResponseAllOfToJSON;
//# sourceMappingURL=CancelPremiumResponseAllOf.js.map